import Swiper from 'swiper';

const archiveRecipesSlider = () => {
  const selectors = {
    swiper: '.js-recipes-slider',
  };

  const swiperContainer = document.querySelector(selectors.swiper);

  if (!swiperContainer) return;

  const swiper = new Swiper(selectors.swiper, {
    slidesPerView: 'auto',
  });
};

export default archiveRecipesSlider;
